var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 139,
    viewBox: "0 0 200 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.987 138.092C187.797 132.39 176.607 127.004 172.134 123.191C168.29 119.903 164.298 116.793 160.307 113.684C156.545 110.753 152.785 107.824 149.152 104.748C146.446 102.516 143.925 100.026 141.397 97.5288C138.836 94.9994 136.268 92.4626 133.493 90.1801C123.736 82.4336 115.227 73.1074 108.287 62.5561C107.936 62.0051 107.599 61.47 107.272 60.9495C104.765 56.9592 102.796 53.8261 98.5838 50.9263C95.413 48.7438 92.1804 47.1209 88.9879 45.5181C87.3856 44.7137 85.7934 43.9144 84.2242 43.052C76.5876 38.8509 68.8101 34.9255 61.0269 30.9971C54.3823 27.6434 47.7334 24.2875 41.1643 20.7563C30.9665 15.2488 19.8826 11.9726 8.83628 8.70751C5.88227 7.83435 2.93095 6.96199 0 6.04797L195.72 8.41197e-05L199.987 138.092Z",
    fill: "#0C1217"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew2);
export default __webpack_public_path__ + "static/media/new_2.4fe96025978911405c3121d2019ce0c8.svg";
export { ForwardRef as ReactComponent };